// removed by extract-text-webpack-plugin
module.exports = {"creditCard":"Card__creditCard___3JgNG","hasError":"Card__hasError___-7oAj","defaultCvv":"Card__defaultCvv___3BCN-","AMEXCvv":"Card__AMEXCvv___g8LPL","visa":"Card__visa___3lTWs","amex":"Card__amex___3tMkf","master_card":"Card__master_card___3As1V","discover":"Card__discover___wB4oG","switch":"Card__switch___1S7Zb","DINER":"Card__DINER___2enrv","jcb":"Card__jcb___eAQLe","maestro":"Card__maestro___1zDF8","cb_nationale":"Card__cb_nationale___1ADgA","confinoga":"Card__confinoga___TFIWr","cofidis":"Card__cofidis___2o5gb","cetelem":"Card__cetelem___l_JdZ","IT":"Card__IT___oKLMC","ES":"Card__ES___EhWUe","C2":"Card__C2___21WQe","cup":"Card__cup___k46Ea","iconText":"Card__iconText___1r8ur"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/types/card/Card.less
 ** module id = 775
 ** module chunks = 0
 **/